import React from 'react';
import './landing.scss';
import {landingContent} from "../demo_page/content";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

class Landing extends React.Component {

    state = {
        imageId: 0,
        wasClicked: false,
        isSwipeLeft: false
    };
    
    componentDidMount() {
        setTimeout(function () {
            document.querySelector(".loader-wrapper").style = "display: none";
        }, 2000);
        
        let intervalId = setInterval(() => {
            this.setState(prevState => {
                if (this.state.wasClicked) {
                    return {
                        wasClicked: false,
                        isSwipeLeft: false
                    }
                }
                if (prevState.imageId < landingContent.length-1) {
                    return {
                        imageId: (prevState.imageId +1),
                    };
                } else {
                    return {
                        imageId: 0,
                    };
                }
            });
        }, 5000);

        this.setState({
            intervalId
        });
    }

    componentWillUnmount() {
        clearInterval(this.state.intervalId);
    }
    
    swipeLeft = () => {
        this.setState(prevState => {
            if (prevState.imageId > 0) {
                return {
                    imageId: (prevState.imageId -1),
                    wasClicked: true,
                    isSwipeLeft: true
                   
                };
            } else {
                return {
                    imageId: landingContent.length -1,
                    wasClicked: true,
                    isSwipeLeft: true
                };
            }
        });
    };

    swipeRight = () => {
        this.setState(prevState => {
            if (prevState.imageId < landingContent.length-1) {
                return {
                    imageId: (prevState.imageId +1),
                    wasClicked: true
                };
            } else {
                return {
                    imageId: 0,
                    wasClicked: true
                };
            }
        });
    };
    
    renderImageContainer = (imageWithDetails) => {
        const isEng = this.props.language && this.props.language === 'ENG';
        const zIndex = imageWithDetails.id === this.state.imageId 
            ? 100
            : this.state.imageId === 0 
                ? this.state.isSwipeLeft 
                    ? imageWithDetails.id === 1 ? 99 : 1 
                    : imageWithDetails.id === 0 ? 99 : 1 
                : this.state.isSwipeLeft 
                    ? this.state.imageId === landingContent.length -1
                        ? imageWithDetails.id === 0 ? 99 : 1
                        : imageWithDetails.id === this.state.imageId + 1 ? 99 : 1
                    : imageWithDetails.id === this.state.imageId - 1 ? 99 : 1
        ;
        
        return <div className={imageWithDetails.id === this.state.imageId ? "image-container fade-in" : "image-container"} 
                    style={{zIndex: zIndex}}
                    key={imageWithDetails.id}
        >
            <img className={"landing-image"} 
                 src={imageWithDetails.src} 
                 alt={isEng ? imageWithDetails.labelEng : imageWithDetails.labelHun}/>
            <div className={"landing-text"}>
                <h2>{isEng ? imageWithDetails.labelEng : imageWithDetails.labelHun}</h2>
                <div className={"landing-desc"}>{isEng ? imageWithDetails.descEng : imageWithDetails.descHun}</div>
            </div>
            <div className="left-button" onClick={() => this.swipeLeft()}>
                <FontAwesomeIcon icon={["fas", "arrow-left"]} />
            </div>
            <div className="right-button" onClick={() => this.swipeRight()}>
                <FontAwesomeIcon icon={["fas", "arrow-right"]} />
            </div>
        </div>
    };
    
    
    render() {
        
        return (
            <section id="home" className="landing">
               {landingContent.map(i => this.renderImageContainer(i))}
            </section>
        );
    }
}


export default Landing;


// WEBPACK FOOTER //
// ./src/components/landing.js